import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = {
  key: 0,
  class: "ctx-modelo"
}
const _hoisted_4 = { class: "subtitulo" }
const _hoisted_5 = {
  key: 0,
  class: "aviso aviso-error"
}
const _hoisted_6 = {
  key: 1,
  class: "info"
}
const _hoisted_7 = {
  key: 0,
  class: "resumen-card"
}
const _hoisted_8 = { class: "resumen-grid" }
const _hoisted_9 = { class: "stat-card" }
const _hoisted_10 = { class: "stat-card" }
const _hoisted_11 = { class: "stat-valor" }
const _hoisted_12 = { class: "stat-card" }
const _hoisted_13 = { class: "stat-valor" }
const _hoisted_14 = { class: "tabs" }
const _hoisted_15 = { class: "contenedor-tabla" }
const _hoisted_16 = {
  key: 0,
  class: "lista-tabla"
}
const _hoisted_17 = { class: "col-num" }
const _hoisted_18 = {
  key: 1,
  class: "mensaje-vacio"
}
const _hoisted_19 = { class: "contenedor-tabla" }
const _hoisted_20 = {
  key: 0,
  class: "lista-tabla"
}
const _hoisted_21 = { class: "col-num" }
const _hoisted_22 = { class: "col-num" }
const _hoisted_23 = { class: "col-num" }
const _hoisted_24 = {
  key: 1,
  class: "mensaje-vacio"
}
const _hoisted_25 = {
  key: 3,
  class: "mensaje-vacio"
}

import { ref, computed, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useGestionResultadosAutoevaluacion } from '@/store/GestionResultadosAutoevaluacion'
import { getProcesosService } from '@/services/ProcesoAutoevaluacionService'
import type { NodoResultado, Clasificacion } from '@/interfaces/ResultadosAutoevaluacion'
import MensajeFlotante from '@/components/MensajeFlotante.vue'

interface AspectoFlat {
  nombre: string
  valoracion: number | null
  grado: string | null
  clasificacion: Clasificacion
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ResultadosConsolidadosView',
  setup(__props) {

/**
 * Resultados consolidados de una versión.
 *
 * ⚠️ Sin escopar por ejecución, los resultados agregan todos los programas y
 * periodos que hayan usado la versión.
 *
 * ── Enrutado ─────────────────────────────────────────────────────
 *   `/version/:id_version/resultados` (ResultadosConsolidados) — permiso `calificacion.ver`
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */

const route = useRoute()
const idVersion = Number(route.params.id_version)
const store = useGestionResultadosAutoevaluacion()
const nombreVersion = ref('')
const errorCarga = ref('')

const mensajeVisible = ref(false)
const mensajeTexto = ref('')
const mensajeTipo = ref<'positivo' | 'error'>('error')

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error' = 'error') {
  mensajeTexto.value = texto
  mensajeTipo.value = tipo
  mensajeVisible.value = true
}

watch(() => store.error, (val) => { if (val) mostrarMensaje(val) })

const tab = ref<'indicadores' | 'componentes'>('indicadores')

function recolectarAspectos(nodo: NodoResultado): AspectoFlat[] {
  const list: AspectoFlat[] = []
  for (const a of nodo.aspectos) {
    list.push({ nombre: a.nombre, valoracion: a.valoracion, grado: a.grado, clasificacion: a.clasificacion })
  }
  for (const h of nodo.hijos) list.push(...recolectarAspectos(h))
  return list
}

const aspectos = computed<AspectoFlat[]>(() => {
  if (!store.resultados) return []
  const list: AspectoFlat[] = []
  for (const f of store.resultados.factores) list.push(...recolectarAspectos(f))
  return list
})

function clasClase(c: Clasificacion): string {
  return `clas-${c}`
}
function clasLabel(c: Clasificacion): string {
  return ({ fuerte: 'Fuerte', debil: 'Débil', muy_debil: 'Muy débil', no_aplica: 'No aplica' } as Record<string, string>)[c] ?? c
}

onMounted(async () => {
  if (!Number.isFinite(idVersion) || idVersion <= 0) {
    errorCarga.value = 'Versión no válida.'
    return
  }
  const procesos = await getProcesosService({ id_version: idVersion })
  if (!procesos.length) {
    errorCarga.value = 'No se encontró un proceso de autoevaluación para esta versión.'
    return
  }
  const proceso = procesos.find(p => p.estado !== 'finalizado') ?? procesos[procesos.length - 1]
  nombreVersion.value = (proceso as any)?.version?.nombre ?? ''
  if (!proceso.id) {
    errorCarga.value = 'El proceso no tiene un identificador válido.'
    return
  }
  await store.cargar(proceso.id)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createElementVNode("h1", null, "Resultados Consolidados", -1)),
        (nombreVersion.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(nombreVersion.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_4, "Versión #" + _toDisplayString(_unref(idVersion)), 1)
      ]),
      _createElementVNode("button", {
        class: "btn salir",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, "Volver")
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (errorCarga.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(errorCarga.value), 1))
      : (_unref(store).cargando)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Cargando resultados…"))
        : (_unref(store).resultados)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (_unref(store).resultados.global)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _cache[8] || (_cache[8] = _createElementVNode("h3", null, "Resumen General", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "stat-label" }, "Calificación Global", -1)),
                        _createElementVNode("span", {
                          class: _normalizeClass(["stat-valor", clasClase(_unref(store).resultados.global.clasificacion)])
                        }, _toDisplayString(_unref(store).resultados.global.valoracion != null ? _unref(store).resultados.global.valoracion.toFixed(2) : '—'), 3)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "stat-label" }, "Porcentaje", -1)),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(store).resultados.global.pct != null ? _unref(store).resultados.global.pct.toFixed(1) + '%' : '—'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "stat-label" }, "Grado", -1)),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(store).resultados.global.grado ?? '—'), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  class: _normalizeClass(["tab", { activo: tab.value === 'indicadores' }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (tab.value = 'indicadores'))
                }, "Por Aspecto", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["tab", { activo: tab.value === 'componentes' }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (tab.value = 'componentes'))
                }, "Por Factor", 2)
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_15, [
                (aspectos.value.length)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_16, [
                      _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Aspecto / Indicador"),
                          _createElementVNode("th", { class: "col-num" }, "Valoración"),
                          _createElementVNode("th", null, "Grado"),
                          _createElementVNode("th", null, "Clasificación")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aspectos.value, (a, i) => {
                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                            _createElementVNode("td", null, _toDisplayString(a.nombre), 1),
                            _createElementVNode("td", _hoisted_17, [
                              _createElementVNode("span", {
                                class: _normalizeClass(clasClase(a.clasificacion))
                              }, _toDisplayString(a.valoracion != null ? a.valoracion.toFixed(2) : '—'), 3)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(a.grado ?? '—'), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge-clas", clasClase(a.clasificacion)])
                              }, _toDisplayString(clasLabel(a.clasificacion)), 3)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_18, "No hay resultados de aspectos."))
              ], 512), [
                [_vShow, tab.value === 'indicadores']
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_19, [
                (_unref(store).resultados.factores.length)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_20, [
                      _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, "Factor"),
                          _createElementVNode("th", { class: "col-num" }, "Ponderación"),
                          _createElementVNode("th", { class: "col-num" }, "Valoración"),
                          _createElementVNode("th", { class: "col-num" }, "%"),
                          _createElementVNode("th", null, "Grado"),
                          _createElementVNode("th", null, "Clasificación")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).resultados.factores, (f) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: f.id_componente
                          }, [
                            _createElementVNode("td", null, _toDisplayString(f.nombre), 1),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(f.peso != null ? f.peso + '%' : '—'), 1),
                            _createElementVNode("td", _hoisted_22, [
                              _createElementVNode("span", {
                                class: _normalizeClass(clasClase(f.clasificacion))
                              }, _toDisplayString(f.valoracion != null ? f.valoracion.toFixed(2) : '—'), 3)
                            ]),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(f.pct != null ? f.pct.toFixed(1) + '%' : '—'), 1),
                            _createElementVNode("td", null, _toDisplayString(f.grado ?? '—'), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge-clas", clasClase(f.clasificacion)])
                              }, _toDisplayString(clasLabel(f.clasificacion)), 3)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_24, "No hay resultados de factores."))
              ], 512), [
                [_vShow, tab.value === 'componentes']
              ])
            ], 64))
          : (!_unref(store).cargando && !errorCarga.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " No hay resultados disponibles para esta versión. "))
            : _createCommentVNode("", true),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[3] || (_cache[3] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})